import * as types from './types';

export const fetchOutageBannerDetailsBegin = () => ({
  type: types.GET_OUTAGE_BANNER_DETAILS_BEGIN
});

export const fetchOutageBannerDetailsSuccess = outageBannerDetails => ({
  type: types.GET_OUTAGE_BANNER_DETAILS_SUCCESS,
  payload: outageBannerDetails
});

export const fetchOutageBannerDetailsFailure = error => ({
  type: types.GET_OUTAGE_BANNER_DETAILS_FAILURE,
  payload: error
});
